import { createComponent, EnvironmentInjector } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sift } from "radash";
import { el, mount } from "src/app/support/dom";
import { CampaignTemplate } from "src/app/backend/models/campaign-template";
import { MessageTemplateScope } from "src/app/backend/models/message-template";
import { TagComponent } from "src/app/components/ui/tag/tag.component";
import { sntTranslate } from "src/app/support/translate";
import { COLORS } from "src/app/support/colors";

type Input = {
  element: HTMLElement;
  applicationRefInjector: EnvironmentInjector;
  template: CampaignTemplate;
};

export function blockWysiwygTemplateMount({
  element,
  applicationRefInjector,
  template: { name, scope }
}: Input): void {
  const systemTemplateScopes = [
    MessageTemplateScope.ACCOUNT,
    MessageTemplateScope.DOMAIN
  ];

  scope = scope ?? MessageTemplateScope.TENANT;

  let sntTagComponent = createComponent(TagComponent, {
    environmentInjector: applicationRefInjector
  });

  [
    ["flex", false],
    ["name", sntTranslate(marker("Sistema")).toUpperCase()],
    ["color", COLORS.SKY_BLUE]
  ].forEach(([input, value]) => {
    sntTagComponent.setInput(<string>input, value);
  });

  //TODO: Remove setTimeout...
  sntTagComponent.changeDetectorRef.detectChanges();
  setTimeout(() => {
    sntTagComponent.changeDetectorRef.detectChanges();
  }, 0);

  const sntTagTemplate = sntTagComponent.location.nativeElement;

  mount(
    element,
    el("div", { class: "flex flex-col gap-1 whitespace-normal" }, [
      el(
        "div",
        { class: "flex flex-row items-center gap-1" },
        sift([
          el(
            "div",
            systemTemplateScopes.includes(scope)
              ? el(
                  "div",
                  { class: "flex flex-row" },
                  sift([
                    el("span", { class: "text-xs text-slate-900" }, name),
                    sntTagTemplate
                  ])
                )
              : el("span", { class: "text-xs text-slate-900" }, name)
          )
        ])
      )
    ])
  );
}
